import cn from "../../../utils/cn";

const Header = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn("-mx-5 -mt-5 p-5 rounded-t-[0.375rem]", className)}
    {...props}
  />
);

export default Header;
